module.exports = __webpack_public_path__ + "static/img/acropolis.129795c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/acropolis.jpg
// module id = ecni
// module chunks = 1